exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-1NGWg{color:#fff;font-size:1rem}.label-1NGWg.required-3S96U{color:#0a81ff}.label-1NGWg.disabled-siz5w{color:#565e85}.theme-dark .label-1NGWg{color:#fff}.theme-dark .label-1NGWg.required-3S96U{color:#0a81ff}.theme-dark .label-1NGWg.disabled-siz5w{color:#565e85}.theme-light .label-1NGWg{color:#212121}.theme-light .label-1NGWg.required-3S96U{color:#0a81ff}.theme-light .label-1NGWg.disabled-siz5w{color:#565e85}", ""]);

// exports
exports.locals = {
	"label": "label-1NGWg",
	"required": "required-3S96U",
	"disabled": "disabled-siz5w"
};